<template>
  <div class="col-md-4">
    <div class="card license-block" :class="{'clickable-block': isActive}" @click.prevent="viewRedirect">
      <div class="card-content">
        <div class="row d-flex align-items-center">
          <div class="col-md-4 text-center">
            <div class="icon-big text-center" :class="statusDataItem('iconClass')">
              <i class="ti-unlock"></i>
            </div>
            <div>
              <span class="label" :class="statusDataItem('labelClass')">{{ statusDataItem('labelText') }}</span>
            </div>
          </div>
          <div class="col-md-8">
            <div v-if="isActive">
              <stats :licenseData="license"/>
            </div>
            <div v-if="isInactive">
              <div class="form-group">
                <label>Attach to server</label>
                <select class="form-control" v-model="activationServer">
                  <option value="">Choose a server</option>
                  <option v-for="server in serversByStatus(1)" :key="server.id" :value="server.id">{{ server.hostname }}</option>
                </select>
              </div>
            </div>
            <div v-if="isPending">
              <p>License is being processed by chosen grab server.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <hr>
        <div class="footer-title">
          <strong>
            <span class="text-muted">Username:</span>
            {{ license.username }}
          </strong>
          <strong v-if="license.server && license.server.hostname">
            <span class="text-muted">Server:</span>
            {{ license.server.hostname }}
          </strong>
          <strong v-if="license.server && license.server.batch && license.server.batch.name">
            <span :class="'label label-'+license.server.batch.color">{{license.server.batch.name}}</span>
          </strong>
        </div>
        <div class="pull-right" v-if="isActive">
          <button class="btn btn-default btn-fill btn-icon btn-sm">
            <i class="ti-angle-right"></i>
          </button>
        </div>
        <div class="pull-right" v-if="isInactive">
          <button class="btn btn-success btn-fill btn-icon btn-sm" @click.prevent="activateLicense">
            Activate
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {mapGetters, mapActions} from 'vuex'
import Stats from "../View/Stats";

export default {
  components: {Stats},
  props: ['license'],
  computed: {
    ...mapGetters(['serversByStatus']),
    statusCode: function () {
      return (this.license && this.license.status) ? this.license.status : 0;
    },
    isActive: function () {
      return this.statusCode === this.statusCodes.active;
    },
    isInactive: function () {
      return this.statusCode === this.statusCodes.inactive;
    },
    isPending: function () {
      return this.statusCode === this.statusCodes.pending;
    },
  },
  data: function () {
    return {
      activationServer: '',
      statusData: {
        0: {
          iconClass: 'icon-default',
          labelClass: 'label-default',
          labelText: 'Unknown',
          buttonClass: '',
        },
        1: {
          iconClass: 'icon-warning',
          labelClass: 'label-warning',
          labelText: 'Inactive',
          buttonClass: '',
        },
        2: {
          iconClass: 'icon-success',
          labelClass: 'label-success',
          labelText: 'Active',
          buttonClass: '',
        },
        3: {
          iconClass: 'icon-info',
          labelClass: 'label-info',
          labelText: 'Pending',
          buttonClass: '',
        },
      },
      statusCodes: {
        unknown: 0,
        inactive: 1,
        active: 2,
        pending: 3
      }
    }
  },
  methods: {
    ...mapActions(['licenseActivate']),
    viewRedirect: function () {
      if (this.isActive) {
        this.$router.push({name: 'license.view', params: {id: this.license.id}});
      }
    },
    statusDataItem: function (type) {
      return this.statusData[this.statusCode][type];
    },
    activateLicense: function () {
      const input = {
        client_id: this.activationServer,
        action: 'license_activate',
        request: JSON.stringify({license_id: this.license.id})
      };
      this.licenseActivate(input);
    }
  }
}
</script>
<style scoped>
.license-block .card-content {
  min-height: 121px;
}

.license-block.clickable-block {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Licenses/List/LicenseCard.vue